import { TableColumn } from './table.model';

/** Nested property of an object ('user.role.name'); undefined when a step is missing */
export function getNestedValue(obj: unknown, path: string): unknown {
	return path
		.split('.')
		.reduce<unknown>(
			(acc, part) =>
				acc !== null && typeof acc === 'object' ? (acc as Record<string, unknown>)[part] : undefined,
			obj,
		);
}

/** A cell value as text for string inputs (avatar name, tooltip...): undefined when empty */
export function cellText(value: unknown): string | undefined {
	return value === null || value === undefined || value === '' ? undefined : String(value);
}

/**
 * Value of a row's field as the table shows it: nested paths supported, and the column's
 * `transform` applied when the field has a column with one.
 */
export function getCellValue<T extends object>(rowData: T, field: string, columns: TableColumn<T>[]): unknown {
	let value: unknown;
	const manager = (rowData as { manager?: { firstName?: string; lastName?: string; email?: string } }).manager;

	if (field === 'manager' && manager) {
		const firstName = manager.firstName || '';
		const lastName = manager.lastName || '';
		value = `${firstName} ${lastName}`.trim() || manager.email || 'Unassigned';
	} else {
		// Nested properties supported (e.g., 'user.name', 'user.role.name')
		value = getNestedValue(rowData, field);
	}

	// Apply transform function if defined in column
	const column = columns.find((col) => col.field === field);
	if (column?.transform && typeof column.transform === 'function') {
		return column.transform(value);
	}

	return value;
}
